import {
  CreateLabelResponse,
  GetLabelsResponse,
  UpdateLabelResponse,
  DeleteLabelResponse,
  GetPhasesReponse,
  CreatePhaseResponse,
  UpdatePhaseResponse,
  DeletePhaseResponse,
} from '../../types/types';
import {
  _deleteArgosV25,
  _getArgosV25,
  _postArgosV25,
  _putArgosV25,
} from './_internal';

export const getLabels = (payload: {
  sensorId: number;
  graphId: number;
}): Promise<GetLabelsResponse> => {
  const route = `api/labels/${payload.sensorId}?graphId=${payload.graphId}`;
  return _getArgosV25({ route: route });
};

export const createLabel = (payload: {
  id_sensor: number;
  time_unix: number;
  position_in_sensor: number;
  label_text: string;
  source: string;
}): Promise<CreateLabelResponse> => {
  const route = `api/labels`;
  return _postArgosV25({
    route: route,
    payload: { ...payload, source: 'MANUAL' },
  });
};

export const updateLabel = (payload: {
  labelId: number;
  time_unix: number;
  position_in_sensor: number;
  label_text: string;
  source: string;
}): Promise<UpdateLabelResponse> => {
  const route = `api/labels/${payload.labelId}`;
  return _putArgosV25({
    route: route,
    payload: { ...payload, source: 'MANUAL' },
  });
};

export const deleteLabel = (payload: {
  labelId: number;
}): Promise<DeleteLabelResponse> => {
  const route = `api/labels/${payload.labelId}`;
  return _deleteArgosV25({ route: route });
};

export const getPhases = (payload: {
  sensorId: number;
}): Promise<GetPhasesReponse> => {
  const route = `api/phases/${payload.sensorId}`;
  return _getArgosV25({ route: route });
};

export const createPhase = (payload: {
  graph_id: number;
  id_sensor: number;
  pk_test_ref_start: number;
  pk_test_ref_end: number;
  time_start: number;
  time_end: number;
  phase_text: string;
  color_hex: string;
}): Promise<CreatePhaseResponse> => {
  const route = `api/phases`;
  return _postArgosV25({
    route: route,
    payload: { ...payload, source: 'MANUAL' },
  });
};

export const updatePhase = (payload: {
  phaseId: number;
  graph_id: number;
  id_sensor: number;
  pk_test_ref_start: number;
  pk_test_ref_end: number;
  time_start: number;
  time_end: number;
  phase_text: string;
  color_hex: string;
}): Promise<UpdatePhaseResponse> => {
  const route = `api/phases/${payload.phaseId}`;
  return _putArgosV25({
    route: route,
    payload: { ...payload, source: 'MANUAL' },
  });
};

export const deletePhase = (payload: {
  phaseId: number;
}): Promise<DeletePhaseResponse> => {
  const route = `api/phases/${payload.phaseId}`;
  return _deleteArgosV25({ route: route });
};
